import React from 'react'
import LargeWidget from '@components/Widgets/LargeWidget';
import { useAppSettings } from '@store/nodeContextStore';
import { useLocalization } from '@store/localizationStore';
import { TextyKRegistracimDodavatel } from '@pages/registrace/TextKRegistracim';
import { useDescription } from '@utils/DescriptionHook';

const RegistraceDodavatel: React.FC = () => {
    const { t } = useLocalization();
    const { getAllWidgetUrl } = useAppSettings();
    useDescription(t('NEN-789456'));

    return (
        <>
            <TextyKRegistracimDodavatel />
            <LargeWidget src={getAllWidgetUrl('registraceDodavatel')} />
        </>
    )
};

export default RegistraceDodavatel;